export enum CommonEnum {
  AUTH_TOKEN = 'wtr/admin-auth-token',
  CONDITION_BAR = 'wtr/admin-bar-condition',
}
